import type { IGroup, IScope, IRule } from '@/types/filterBuilderTypes';

export function isGroup(scope: IScope): scope is IGroup {
    return (scope as IGroup).rules !== undefined;
}

export function isRule(scope: IScope): scope is IRule {
    return (scope as IRule).column !== undefined;
}